import React, { useEffect } from "react";
import { Integration } from "../../../types/integration";
import { Form, Input, Modal } from "antd";

export interface IntegrationFormProps {
  open: boolean;
  record?: Integration;
  onSave: (record: Integration) => void;
  onCancel: () => void;
}

export const IntegrationForm = (props: IntegrationFormProps) => {
  const [form] = Form.useForm<Integration>();
  const { record, open } = props;

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(record ?? {});
  }, [record, open, form]);

  return (
    <Modal
      open={props.open}
      title={record ? "Edit Integration" : "Add Integration"}
      okText={record ? "Save" : "Add"}
      cancelText="Cancel"
      onCancel={props.onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            props.onSave(values);
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
    >
      <Form form={form} layout="vertical" name="integration_form">
        <Form.Item
          name="artifact"
          label="Artifact"
          rules={[{ required: true, message: "Please input the artifact!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="version"
          label="Version"
          rules={[{ required: true, message: "Please input the version!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="source" label="Source">
          <Input />
        </Form.Item>
        <Form.Item name="comment" label="Comment">
          <Input />
        </Form.Item>
        <Form.Item name="deploymentTarget" label="Minimal OS Version">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
